export interface LiqPayFormPayload {
  publicKey: string;
  data: string;
  signature: string;
  actionUrl: string;
}

export type LiqPayCheckoutTarget = {
  readonly name: string;
  readonly handle: Window | null;
};

export const prepareLiqPayCheckoutTarget = (): LiqPayCheckoutTarget => {
  const name = `liqpay-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const handle = window.open('', name);

  if (handle) {
    try {
      handle.document.write(
        '<!doctype html><html><head><meta charset="utf-8"><title>Redirecting…</title></head><body></body></html>',
      );
      handle.document.close();
    } catch {
      // Safari can keep the handle while restricting document access. The named window is still usable as a form target.
    }
  }

  return { name, handle };
};

export const submitLiqPayForm = (
  payload: LiqPayFormPayload,
  target: LiqPayCheckoutTarget | null = null,
) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = payload.actionUrl;
  form.target = target?.name ?? '_blank';
  form.acceptCharset = 'utf-8';

  const injectField = (name: string, value: string) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  injectField('public_key', payload.publicKey);
  injectField('data', payload.data);
  injectField('signature', payload.signature);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
